import { filter, first, isEmpty, isInteger, last, split } from 'lodash';
import Link from 'next/link';
import React from 'react';
import { getContentPagePath, getProjectPagePath } from './urlGenerator';
import { VideoType } from '../domain/videoTypes';

class UrlHelper {
  static withLink(href: string, as: string) {
    const attributes = { href, as };

    return (children: React.ReactNode) => {
      return (
        <Link {...attributes} prefetch={false} legacyBehavior>
          {children}
        </Link>
      );
    };
  }

  static parsePath(url: string) {
    const urlSplitByDash = split(url, '-');
    const filterInt = filter(urlSplitByDash, function (elemen) {
      return Number(elemen) >= 1;
    });
    const id =
      !isEmpty(last(filterInt)) && isInteger(parseInt(last(filterInt)))
        ? last(filterInt)
        : '';
    const urlSplitById = split(url, id);

    const slug = !isEmpty(first(urlSplitById)) ? first(urlSplitById) : '';

    return {
      id,
      slug,
    };
  }

  static isContentPageLegacy(path: string) {
    return /^\/\d{4}\/\d{2}\/\d{2}\/[a-zA-Z\-\d\u0E00-\u0E7F]+\/*$/i.test(path);
  }

  static isProjectPageLegacy(path: string) {
    return /^\/(condo|house)\/[a-zA-Z\-\d\u0E00-\u0E7F]+\/*$/i.test(path);
  }

  static getPostUrlInfo(
    content: {
      propertyType?: string[];
      title?: string;
      id?: number | string;
      postCategory?: string;
      link: string;
      videoType?: VideoType;
    },
    currentUrl: string,
    isProjectUrl = false,
  ) {
    const expectedUrl = isProjectUrl
      ? getProjectPagePath(content.link)
      : getContentPagePath(content);

    return {
      isValid:
        this.getUrlWithoutQueryString(currentUrl) === encodeURI(expectedUrl),
      actualUrl: expectedUrl,
    };
  }

  static getUrlWithoutQueryString(url: string) {
    if (url.lastIndexOf('?') === -1) {
      return url;
    } else {
      return url.substring(0, url.lastIndexOf('?'));
    }
  }

  static getQueryStringFromUrl(url: string) {
    if (url.lastIndexOf('?') === -1) {
      return '';
    } else {
      return url.substring(url.lastIndexOf('?'), url.length);
    }
  }
}

export default UrlHelper;
